<template>
    <v-main>
        <v-container fluid fill-height class="px-0 mb-14 mb-lg-0">
            <transition name="slide" mode="out-in">
                <router-view/>
            </transition>
        </v-container>
        <v-bottom-navigation grow fixed dark background-color="primary" color="accent" class="hidden-lg-and-up">
            <v-btn class="px-1" to="/login">
                <span>Iniciar Sesión</span>
                <v-icon>mdi-account-key</v-icon>
            </v-btn>
            <v-btn class="px-1" to="/register">
                <span>Crear Cuenta</span>
                <v-icon>mdi-account-plus</v-icon>
            </v-btn>
        </v-bottom-navigation>
    </v-main>
</template>

<script>
export default {}
</script>

<style scoped>

</style>
